webpackJsonp([195761378839565],{

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(117);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Institutions = function (_React$Component) {
	  _inherits(Institutions, _React$Component);
	
	  function Institutions() {
	    _classCallCheck(this, Institutions);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Institutions.prototype.componentDidMount = function componentDidMount() {
	    this.context.setAltLanguages(undefined);
	  };
	
	  Institutions.prototype.render = function render() {
	    var json = "";
	    if (this.props.data.page.raw) {
	      json = JSON.parse(this.props.data.page.raw);
	    }
	    if (this.props.data.institutions) {
	      this.props.data.institutions.edges.sort(function (a, b) {
	        if (a.node.uid < b.node.uid) return -1;
	        if (a.node.uid > b.node.uid) return 1;
	        return 0;
	      });
	    }
	    return _react2.default.createElement(
	      "div",
	      {
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      _react2.default.createElement(_components.Head, { source: json.data }),
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: "About | Bank Information Center",
	        meta: [{ name: "description", content: "Sample" }, { name: "keywords", content: "sample, something" }]
	      }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        _react2.default.createElement(
	          _components.PageHeader,
	          { title: json.data.title[0].text, color: json.uid },
	          json.data.subtitle[0] && _react2.default.createElement(_components.H2, { children: json.data.subtitle[0].text, fontSize: [4, 5] }),
	          json.data.description[0] && _react2.default.createElement(_components.Text, { children: json.data.description[0].text })
	        ),
	        _react2.default.createElement(
	          _components.PageSection,
	          null,
	          json.data.body1[0] && _react2.default.createElement(
	            _components.PageSidebar,
	            null,
	            json.data.body1.map(function (callout, index) {
	              return _react2.default.createElement(_components.CalloutCard, {
	                key: "callout" + index,
	                callout: callout.primary,
	                lang: json.lang
	              });
	            })
	          ),
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            _react2.default.createElement(
	              _components.Accordion,
	              {
	                title: json.lang === "en-us" ? "What is an International Financial Institution and what do they do?" : json.lang === "es-mx" ? "¿Qué es una institución financiera internacional y qué hace?" : "ما هي مؤسسات التمويل الدولية وما هو دورها؟",
	                id: "what_tab",
	                data: []
	              },
	              json.data.body && _react2.default.createElement(_components.Article, {
	                dangerouslySetInnerHTML: {
	                  __html: _prismicDom.RichText.asHtml(json.data.body, linkResolver)
	                }
	              })
	            ),
	            this.props.data.institutions && _react2.default.createElement(
	              _rebass.Box,
	              { mt: 6 },
	              this.props.data.institutions.edges.map(function (institution, index) {
	                return _react2.default.createElement(_components.InstitutionCard, {
	                  key: "institution" + index,
	                  object: institution.node
	                });
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Institutions;
	}(_react2.default.Component);
	
	Institutions.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Institutions;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-institutions-js-de324d23a44aae21785a.js